import React from 'react'
import type {IContentItem} from '@kontent-ai/delivery-sdk'
import type {Block} from '@/_new-code/services/kontent-ai/types'

export type PearCommerceWidgetContentItem = IContentItem<{
	// No specific elements needed for this component
}>

export const PearCommerceWidget: Block<PearCommerceWidgetContentItem> = () => {
	// Create the target div that Pear Commerce will use to render its widget
	return (
		<div
			data-kontent-element-codename="pear_commerce_widget_guidelines"
			id="pear-pdp-target"
		/>
	)
}
